import React from "react";

class ReelsPlayer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            playlistId: props.playlistId || window.reels.playlistId || '',
            brand: props.brand || window.reels.brand || '',
            site: props.site || window.reels.site || '',
        };
    }

    componentDidMount() {
        this.loadReelsScript();
    }

    loadReelsScript() {
        // Check if script is already loaded
        if (document.getElementById('reels-player-script')) {
            return;
        }

        // Load the script
        const script = document.createElement('script');
        script.id = 'reels-player-script';
        script.src = 'https://cdn.video.aller.com/loader/latest/script.js';
        document.body.appendChild(script);
    }

    render() {
        if (!this.state.playlistId) {
            return null;
        }

        return (
            <div
                className="aller-video-container carousel"
                data-brand={this.state.brand}
                data-playlist-id={this.state.playlistId}
                data-site={this.state.site}
                data-variant="carousel"
            ></div>
        );
    }
}

export default ReelsPlayer;
